export default __webpack_public_path__ + "2a19b23d5cfcbdfab870479b238317da.svg";